import { Link } from 'react-router-dom';

/**
 * Static support surface: no permission key, API call, or tenant data.
 *
 * TASK 300A — this card asserts no outcome and presupposes none.
 *
 * The BODY states the outcome set: the platform reviews, then
 * activates OR declines. «يدوياً» sits on «يفعّل» because activation
 * is the manual part. The payment clause is preserved byte-for-byte.
 *
 * The TITLE states the current fact and nothing about the future.
 * Two earlier wordings shipped here and both smuggled the promise
 * back in — «بانتظار التفعيل» (awaiting THE activation) and «قبل
 * تفعيل» (BEFORE the activation, i.e. it is coming). The second was
 * introduced by a fix for an unrelated complaint about the title, so
 * `commercialCopy.shape.test.ts` now pins both out by exact literal
 * rather than trusting review to catch a third.
 */
export function SupportPage() {
  return (
    <main
      dir="rtl"
      style={{ maxWidth: 820, margin: '0 auto', padding: '48px 24px' }}
      data-testid="support-page"
    >
      <div className="page-head">
        <div>
          <span className="pill">المساعدة</span>
          <h1 className="h-page" style={{ marginTop: 10 }}>
            كيف نساعدك؟
          </h1>
          <p className="sub">معلومات مختصرة عن إنشاء الوكالة، التفعيل اليدوي، واستعادة الوصول.</p>
        </div>
      </div>

      <div className="stack-md" style={{ marginTop: 24 }}>
        <SupportItem
          title="حساب الوكالة غير مفعّل"
          body="أكمل ملف الوكالة القانوني أولاً. يراجع فريق المنصة البيانات، ثم يفعّل حساب الوكالة يدوياً أو يعتذر عن الطلب؛ لا يوجد دفع إلكتروني أو تفعيل تلقائي في هذه المرحلة."
        />
        <SupportItem
          title="لم يصل رابط تأكيد البريد"
          body="تحقق من البريد غير المرغوب فيه، ثم ارجع إلى صفحة إنشاء الوكالة وأعد إرسال الطلب. روابط التأكيد مؤقتة وتُستخدم مرة واحدة."
        />
        <SupportItem
          title="الحساب موقوف أو منتهي"
          body="لا يمكن تشغيل الوكالة أو تعديل ملفها في هذه الحالة. تواصل مع مسؤول المنصة عبر قناة الدعم المعتمدة لدى وكالتك."
        />
      </div>

      <div style={{ display: 'flex', gap: 10, marginTop: 24, flexWrap: 'wrap' }}>
        <Link className="btn btn-primary" to="/app">
          العودة إلى الحساب
        </Link>
        <Link className="btn btn-ghost" to="/login">
          تسجيل الدخول
        </Link>
      </div>
    </main>
  );
}

function SupportItem({ title, body }: { readonly title: string; readonly body: string }) {
  return (
    <section className="card" style={{ padding: 20 }}>
      <h2 className="h-section">{title}</h2>
      <p className="body" style={{ marginTop: 8, lineHeight: 1.8 }}>
        {body}
      </p>
    </section>
  );
}
